import { p as proxyCustomElement, H, d as createEvent, h, c as Host } from './p-92c4a1ea.js';
import { Z as doWhenDefaultIsNotPrevented, aq as isNumber, a7 as KeyboardCode, ap as isPositiveNumber, i as isSSR, af as stringToNumberArray } from './p-a57042e3.js';
import { a as accessibilityAttributes, b as accessibility } from './p-756e7dc5.js';
import { u as useRef } from './p-e952b680.js';
import { a as ComponentUtils } from './p-de830ba7.js';
import { O as OnElementMutation } from './p-7b2053f2.js';
import { d as defineCustomElement$k } from './p-49749ba7.js';
import { d as defineCustomElement$j } from './p-35b617b4.js';
import { d as defineCustomElement$i } from './p-69451510.js';
import { d as defineCustomElement$h } from './p-d7980c17.js';
import { d as defineCustomElement$g } from './p-8bd1db02.js';
import { d as defineCustomElement$f } from './p-8bfe5ab0.js';
import { d as defineCustomElement$e } from './p-0585e0e2.js';
import { d as defineCustomElement$d } from './p-25396692.js';
import { d as defineCustomElement$c } from './p-3a198e00.js';
import { d as defineCustomElement$b } from './p-21c18302.js';
import { d as defineCustomElement$a } from './p-7bb98ead.js';
import { d as defineCustomElement$9 } from './p-867a1c3b.js';
import { d as defineCustomElement$8 } from './p-96ee8029.js';
import { d as defineCustomElement$7 } from './p-a83b6d5f.js';
import { d as defineCustomElement$6 } from './p-106f8152.js';
import { d as defineCustomElement$5 } from './p-c5978c85.js';
import { d as defineCustomElement$4 } from './p-64655ed0.js';
import { d as defineCustomElement$3 } from './p-096bd431.js';
import { d as defineCustomElement$2 } from './p-c953c88d.js';
const paginationCss = ".sc-owc-pagination-h{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:justify;justify-content:space-between;font-family:var(--one-typography-font-family);font-size:var(--one-typography-desktop-subtitle-1-font-size);line-height:var(--one-typography-desktop-subtitle-1-line-height);-webkit-font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-kerning:var(--one-typography-desktop-subtitle-1-font-kerning);font-weight:var(--one-text-font-weight-regular);width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;gap:var(--one-spacing-gap-m);min-height:var(--one-spacing-size-l);padding:var(--one-spacing-padding-4-xs) var(--one-spacing-padding-2-xs);white-space:nowrap}.sc-owc-pagination-h .owc-pagination__step-indicator.sc-owc-pagination{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:start;justify-content:flex-start;gap:inherit}.sc-owc-pagination-h .owc-pagination__step-indicator.sc-owc-pagination owc-select-dropdown.sc-owc-pagination{width:calc(var(--one-spacing-size-7-xs) * 100)}.sc-owc-pagination-h .owc-pagination__jump-to-page.sc-owc-pagination{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;gap:var(--one-spacing-gap-5-xs)}.sc-owc-pagination-h .owc-pagination__jump-to-page.sc-owc-pagination owc-input.sc-owc-pagination{width:var(--one-spacing-size-2-xl)}.sc-owc-pagination-h .owc-pagination__icon-wrapper.sc-owc-pagination{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-align:center;align-items:center;-ms-flex-pack:end;justify-content:flex-end;gap:var(--one-spacing-gap-4-xs)}@media screen and (min-width: 0) and (max-width: 319px){.sc-owc-pagination-h .owc-pagination__step-indicator.sc-owc-pagination{display:none}}@media screen and (forced-colors: active) and (min-width: 0) and (max-width: 319px){.sc-owc-pagination-h{border-bottom:var(--one-spacing-outline-regular) solid canvastext}}";
const OwcPaginationStyle0 = paginationCss;
var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const FIRST_PAGE = 1;
const ONE_STEP = 1;
const FOCUS_TIMEOUT = 100;
const Pagination = /*@__PURE__*/proxyCustomElement(class Pagination extends H {
  constructor() {
    super();
    this.__registerHost();
    this.pageChange = createEvent(this, "pageChange", 3);
    this.component = new ComponentUtils(this);
    this.rowsPerPageContainer = useRef();
    this.previousPageButton = useRef();
    this.nextPageButton = useRef();
    this.lastPageButton = useRef();
    this.firstPageButton = useRef();
    this.setPage = newValue => {
      if (newValue !== this.page) {
        if (this.controlled) {
          this.pageChange.emit({
            page: newValue,
            pageSize: this.pageSize,
            total: this.total
          });
        } else {
          this.page = newValue;
        }
      }
    };
    this.getLimitedPageNumber = page => Math.max(FIRST_PAGE, Math.min(page, this.total));
    this.isInFirstPage = () => this.page <= FIRST_PAGE;
    this.isInLastPage = () => this.page >= this.total;
    this.onPerPageDropdownValueChanged = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => isNumber(ev.detail[0]) && (this.pageSize = +ev.detail[0]));
    };
    this.onFirstPageClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.setPage(this.getLimitedPageNumber(FIRST_PAGE)));
    };
    this.onPreviousPageClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.setPage(this.getLimitedPageNumber(this.page - ONE_STEP)));
    };
    this.onNextPageClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.setPage(this.getLimitedPageNumber(this.page + ONE_STEP)));
    };
    this.onLastPageClicked = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.setPage(this.getLimitedPageNumber(this.total)));
    };
    this.onInputKeyDown = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      if (this.inputText && [KeyboardCode.Enter, KeyboardCode.NumpadEnter].includes(ev.code)) {
        this.updatePageFromInputText();
      }
    };
    this.onInputValueChanged = (ev, originalHandler) => {
      originalHandler === null || originalHandler === void 0 ? void 0 : originalHandler(ev);
      doWhenDefaultIsNotPrevented(ev, () => this.inputText = ev.detail);
    };
    this.page = FIRST_PAGE;
    this.total = FIRST_PAGE;
    this.pageSize = 1;
    this.hidePageSize = false;
    this.hideFirstPageButton = false;
    this.hideLastPageButton = false;
    this.hidePagesNumber = false;
    this.hidePreviousPageButton = false;
    this.hideNextPageButton = false;
    this.showJumpToPage = false;
    this.controlled = false;
    this.pageSizeOptions = [];
    this.selectDropdownProps = undefined;
    this.firstPageButtonProps = undefined;
    this.previousPageButtonProps = undefined;
    this.nextPageButtonProps = undefined;
    this.lastPageButtonProps = undefined;
    this.inputProps = undefined;
    this.rowsPerPageText = undefined;
    this.inputText = undefined;
  }
  onAttributeChange() {
    !this.controlled && this.pageChange.emit({
      page: this.getLimitedPageNumber(this.page),
      pageSize: this.pageSize,
      total: this.total
    });
    !!this.showJumpToPage && this.updateInputTextFromPage();
  }
  updateRowsPerPageText() {
    var _a;
    this.rowsPerPageText = (_a = this.rowsPerPageContainer.current) === null || _a === void 0 ? void 0 : _a.textContent;
  }
  updateInputTextFromPage() {
    var _a;
    this.inputText = `${(_a = this.page) !== null && _a !== void 0 ? _a : ''}`;
  }
  updatePageFromInputText() {
    isPositiveNumber(this.inputText) && this.setPage(this.getLimitedPageNumber(parseInt(this.inputText, 10)));
  }
  componentDidLoad() {
    this.updateRowsPerPageText();
    !!this.showJumpToPage && this.updateInputTextFromPage();
  }
  componentWillRender() {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (this.isInLastPage() && !isSSR() && (((_b = (_a = this.lastPageButton) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) || ((_d = (_c = this.nextPageButton) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 ? void 0 : _d.contains(document.activeElement)))) {
      setTimeout(() => {
        var _a, _b;
        return (_b = (_a = this.previousPageButton) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
      }, FOCUS_TIMEOUT);
    }
    if (this.isInFirstPage() && !isSSR() && (((_f = (_e = this.firstPageButton) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.contains(document.activeElement)) || ((_h = (_g = this.previousPageButton) === null || _g === void 0 ? void 0 : _g.current) === null || _h === void 0 ? void 0 : _h.contains(document.activeElement)))) {
      setTimeout(() => {
        var _a, _b;
        return (_b = (_a = this.nextPageButton) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.focus();
      }, FOCUS_TIMEOUT);
    }
  }
  getInputElement() {
    const _a = this.inputProps || {},
      {
        onValueChange: originalOnInputValueChange,
        onkeydown: originalOnInputKeyDown
      } = _a,
      inputProps = __rest(_a, ["onValueChange", "onkeydown"]);
    return h("owc-input", Object.assign({
      variant: "outlined",
      size: "small",
      type: "number",
      min: 1,
      max: this.total,
      maxlength: this.total.toString().length,
      showCharCount: false,
      noClearIcon: true
    }, inputProps, {
      value: this.inputText,
      onValueChange: e => this.onInputValueChanged(e, originalOnInputValueChange),
      onKeyDown: e => this.onInputKeyDown(e, originalOnInputKeyDown)
    }));
  }
  renderIcons(hostClasses) {
    const iconWrapper = this.component.getChildBemClasses('icon-wrapper', hostClasses);
    const _a = this.firstPageButtonProps || {},
      {
        onclick: originalFirstPageOnClick
      } = _a,
      firstPageButtonProps = __rest(_a, ["onclick"]);
    const _b = this.previousPageButtonProps || {},
      {
        onclick: originalPreviousPageOnClick
      } = _b,
      previousPageButtonProps = __rest(_b, ["onclick"]);
    const _c = this.nextPageButtonProps || {},
      {
        onclick: originalNextPageOnClick
      } = _c,
      nextPageButtonProps = __rest(_c, ["onclick"]);
    const _d = this.lastPageButtonProps || {},
      {
        onclick: originalLastPageOnClick
      } = _d,
      lastPageButtonProps = __rest(_d, ["onclick"]);
    return h("div", {
      class: iconWrapper
    }, !this.hideFirstPageButton ? h("owc-icon-button", Object.assign({
      ref: this.firstPageButton,
      family: "outlined",
      icon: "chevron_rewind",
      variant: "inner",
      size: "small",
      disabled: this.isInFirstPage(),
      alt: "First page"
    }, firstPageButtonProps, {
      onClick: e => this.onFirstPageClicked(e, originalFirstPageOnClick)
    })) : null, !this.hidePreviousPageButton ? h("owc-icon-button", Object.assign({
      family: "outlined",
      icon: "chevron_left",
      variant: "inner",
      size: "small",
      disabled: this.isInFirstPage(),
      alt: "Previous page"
    }, previousPageButtonProps, {
      nativeButtonProps: {
        ref: this.previousPageButton
      },
      onClick: e => this.onPreviousPageClicked(e, originalPreviousPageOnClick)
    })) : null, !this.hideNextPageButton ? h("owc-icon-button", Object.assign({
      family: "outlined",
      icon: "chevron_right",
      variant: "inner",
      size: "small",
      disabled: this.isInLastPage(),
      alt: "Next Page"
    }, nextPageButtonProps, {
      nativeButtonProps: {
        ref: this.nextPageButton
      },
      onClick: e => this.onNextPageClicked(e, originalNextPageOnClick)
    })) : null, !this.hideLastPageButton ? h("owc-icon-button", Object.assign({
      ref: this.lastPageButton,
      family: "outlined",
      icon: "chevron_fast_forward",
      variant: "inner",
      size: "small",
      disabled: this.isInLastPage(),
      alt: "Last page"
    }, lastPageButtonProps, {
      onClick: e => this.onLastPageClicked(e, originalLastPageOnClick)
    })) : null);
  }
  render() {
    const hostClasses = this.component.getHostBemClasses();
    const stepIndicator = this.component.getChildBemClasses('step-indicator', hostClasses);
    const jumpToPageWrapper = this.component.getChildBemClasses('jump-to-page', hostClasses);
    const _a = this.selectDropdownProps || {},
      {
        onValueChange: originalOnSelectDropdownValueChange
      } = _a,
      selectDropdownProps = __rest(_a, ["onValueChange"]);
    return h(Host, Object.assign({
      key: '47310f949b0fdffcfa1df151ea556ae3939f3050',
      class: hostClasses
    }, accessibility({
      role: 'navigation'
    })), !this.hidePageSize ? h("div", {
      class: stepIndicator
    }, h("slot", {
      name: "rows-per-page",
      ref: this.rowsPerPageContainer
    }), h("owc-select-dropdown", Object.assign({
      size: "small",
      variant: "outlined",
      value: [this.pageSize],
      label: this.rowsPerPageText,
      noClearIcon: true
    }, selectDropdownProps, {
      onValueChange: e => this.onPerPageDropdownValueChanged(e, originalOnSelectDropdownValueChange)
    }), stringToNumberArray(this.pageSizeOptions).map(item => h("owc-list-item", {
      key: `rows-per-page-${item}`,
      value: item,
      selected: item === this.pageSize
    }, item)))) : null, !this.hidePagesNumber ? h("slot", Object.assign({
      name: "indicator"
    }, accessibilityAttributes({
      live: 'polite'
    })), this.getLimitedPageNumber(this.page), " of ", this.total) : null, this.showJumpToPage ? h("div", {
      class: jumpToPageWrapper
    }, this.getInputElement(), h("owc-typography", {
      variant: "subtitle1",
      device: "desktop"
    }, "/ ", this.total)) : null, this.renderIcons(hostClasses));
  }
  get hostElement() {
    return this;
  }
  static get watchers() {
    return {
      "total": ["onAttributeChange"],
      "pageSize": ["onAttributeChange"],
      "page": ["onAttributeChange"]
    };
  }
  static get style() {
    return OwcPaginationStyle0;
  }
}, [6, "owc-pagination", {
  "page": [1538],
  "total": [514],
  "pageSize": [1538, "page-size"],
  "hidePageSize": [516, "hide-page-size"],
  "hideFirstPageButton": [516, "hide-first-page-button"],
  "hideLastPageButton": [516, "hide-last-page-button"],
  "hidePagesNumber": [516, "hide-pages-number"],
  "hidePreviousPageButton": [516, "hide-previous-page-button"],
  "hideNextPageButton": [516, "hide-next-page-button"],
  "showJumpToPage": [516, "show-jump-to-page"],
  "controlled": [516],
  "pageSizeOptions": [513, "page-size-options"],
  "selectDropdownProps": [16],
  "firstPageButtonProps": [16],
  "previousPageButtonProps": [16],
  "nextPageButtonProps": [16],
  "lastPageButtonProps": [16],
  "inputProps": [16],
  "rowsPerPageText": [32],
  "inputText": [32]
}, undefined, {
  "total": ["onAttributeChange"],
  "pageSize": ["onAttributeChange"],
  "page": ["onAttributeChange"]
}]);
__decorate([OnElementMutation({
  target: hostInstance => hostInstance.rowsPerPageContainer.current,
  childList: true,
  characterData: true,
  subtree: true
})], Pagination.prototype, "updateRowsPerPageText", null);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["owc-pagination", "owc-base-dropdown", "owc-button", "owc-card", "owc-checkbox", "owc-component-footer", "owc-component-header", "owc-divider", "owc-focus-trap", "owc-icon", "owc-icon-button", "owc-input", "owc-list", "owc-list-item", "owc-menu", "owc-popover", "owc-radio", "owc-select-dropdown", "owc-tooltip", "owc-typography"];
  components.forEach(tagName => {
    switch (tagName) {
      case "owc-pagination":
        if (!customElements.get(tagName)) {
          customElements.define(tagName, Pagination);
        }
        break;
      case "owc-base-dropdown":
        if (!customElements.get(tagName)) {
          defineCustomElement$k();
        }
        break;
      case "owc-button":
        if (!customElements.get(tagName)) {
          defineCustomElement$j();
        }
        break;
      case "owc-card":
        if (!customElements.get(tagName)) {
          defineCustomElement$i();
        }
        break;
      case "owc-checkbox":
        if (!customElements.get(tagName)) {
          defineCustomElement$h();
        }
        break;
      case "owc-component-footer":
        if (!customElements.get(tagName)) {
          defineCustomElement$g();
        }
        break;
      case "owc-component-header":
        if (!customElements.get(tagName)) {
          defineCustomElement$f();
        }
        break;
      case "owc-divider":
        if (!customElements.get(tagName)) {
          defineCustomElement$e();
        }
        break;
      case "owc-focus-trap":
        if (!customElements.get(tagName)) {
          defineCustomElement$d();
        }
        break;
      case "owc-icon":
        if (!customElements.get(tagName)) {
          defineCustomElement$c();
        }
        break;
      case "owc-icon-button":
        if (!customElements.get(tagName)) {
          defineCustomElement$b();
        }
        break;
      case "owc-input":
        if (!customElements.get(tagName)) {
          defineCustomElement$a();
        }
        break;
      case "owc-list":
        if (!customElements.get(tagName)) {
          defineCustomElement$9();
        }
        break;
      case "owc-list-item":
        if (!customElements.get(tagName)) {
          defineCustomElement$8();
        }
        break;
      case "owc-menu":
        if (!customElements.get(tagName)) {
          defineCustomElement$7();
        }
        break;
      case "owc-popover":
        if (!customElements.get(tagName)) {
          defineCustomElement$6();
        }
        break;
      case "owc-radio":
        if (!customElements.get(tagName)) {
          defineCustomElement$5();
        }
        break;
      case "owc-select-dropdown":
        if (!customElements.get(tagName)) {
          defineCustomElement$4();
        }
        break;
      case "owc-tooltip":
        if (!customElements.get(tagName)) {
          defineCustomElement$3();
        }
        break;
      case "owc-typography":
        if (!customElements.get(tagName)) {
          defineCustomElement$2();
        }
        break;
    }
  });
}
const OwcPagination = Pagination;
const defineCustomElement = defineCustomElement$1;
export { OwcPagination, defineCustomElement };